<ng-container *ngIf="requestEntity && currentUser; else noData">
  <div *ngIf="requestEntity && currentUser" xmlns="http://www.w3.org/1999/html" class="header">
    <app-show-header-data
      [id]="requestEntity?.id"
      [state]="state"
      [title]="title"
      [statusModule]="statusModule"></app-show-header-data>

    <app-show-create-update-data [createUpdateEntity]="requestEntity"></app-show-create-update-data>
    <app-show-next-action-info
      *ngIf="requestEntity.nextActionType && nextActionActive"
      [action]="requestEntity.nextActionType" />

    <ng-container *ngIf="!actionButtonsBottom">
      <app-dynamic-action-button-row
        [actions]="actions"
        [requestEntity]="requestEntity"
        [currentUser]="currentUser"
        (onActionClickedEvent)="onActionClickedEvent.emit($event)"></app-dynamic-action-button-row>
    </ng-container>

    <app-hint-card
      *ngIf="hintContent()"
      [type]="hintType"
      [outlined]="true"
      style="margin-right: auto"
      [cardStyle]="{
        backgroundColor: 'white'
      }">
      <div [innerHTML]="hintContent() | safeHtmlPipe"></div>
    </app-hint-card>

    <app-show-errors [errorFormList]="errors"></app-show-errors>
  </div>

  <div class="content">
    <ng-content select="[body]"></ng-content>
  </div>

  <ng-container *ngIf="actionButtonsBottom">
    <div *ngIf="this.requestEntity && this.currentUser; else noData" class="footer">
      <app-dynamic-action-button-row
        [actions]="actions"
        [requestEntity]="requestEntity"
        [currentUser]="currentUser"
        (onActionClickedEvent)="onActionClickedEvent.emit($event)"></app-dynamic-action-button-row>
    </div>
  </ng-container>
</ng-container>

<ng-template #noData>
  <ng-container *ngIf="!errorMessage; else showError"><app-loading-overlay /></ng-container>
  <ng-template #showError>
    <app-error [errorMessage]="errorMessage" />
  </ng-template>
</ng-template>
